import { render, staticRenderFns } from "./DayScheduleItem.vue?vue&type=template&id=350c2383&scoped=true&"
import script from "./DayScheduleItem.vue?vue&type=script&lang=js&"
export * from "./DayScheduleItem.vue?vue&type=script&lang=js&"
import style0 from "./DayScheduleItem.vue?vue&type=style&index=0&id=350c2383&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c2383",
  null
  
)

export default component.exports